import * as React from "react";

function IcFlagCircularVn(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      data-id="IcFlagCircularVn"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <rect width={24} height={24} />
        <g fillRule="nonzero" transform="translate(2 2)">
          <path
            fill="#EC0015"
            d="M0,10 C0,4.4771525 4.47593818,0 10,0 L10,0 C15.5228475,0 20,4.47593818 20,10 L20,10 C20,15.5228475 15.5240618,20 10,20 L10,20 C4.4771525,20 0,15.5240618 0,10 L0,10 Z"
          />
          <polygon
            fill="#FF0"
            points="13.111 14.977 10.013 12.654 6.93 15 8.077 11.188 5 8.834 8.807 8.801 9.987 5 11.193 8.792 15 8.797 11.939 11.173 13.111 14.977"
          />
        </g>
        <circle cx={12} cy={12} r={10} stroke={color} strokeWidth={2} />
      </g>
    </svg>
  );
}

export default IcFlagCircularVn;
